const CheckoutError = require('@/lib/Checkout/CheckoutError');
const CheckoutStage = require('@/lib/Checkout/CheckoutStage');

class UserCancelledPaymentError extends CheckoutError {
    constructor() {
        super(CheckoutStage.TAKE_PAYMENT);

        this.shouldClearPayments();
    }
}

module.exports = UserCancelledPaymentError;
